import { hasValidCoordinates, isCityLevelHelperLocationSearch } from "./locationSearchMode";

export const getLocalMarketLookupKey = (locationData = null) => {
  const latitude = Number(locationData?.latitude);
  const longitude = Number(locationData?.longitude);
  if (!hasValidCoordinates(latitude, longitude)) return "";

  return [
    latitude.toFixed(4),
    longitude.toFixed(4),
    locationData?.city || locationData?.locality || "",
    locationData?.region_code ||
      locationData?.stateCode ||
      locationData?.state_code ||
      locationData?.region ||
      locationData?.state ||
      "",
    isCityLevelHelperLocationSearch({ locationData }) ? "city" : "exact",
  ].join("|");
};
